import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ReceiptPage from "./pages/ReceiptPage";
import { AuthProvider } from "./data/AuthContext";
import { ReceiptProvider } from "./data/ReceiptContext";
import "./App.scss";

function App() {
  return (
    <AuthProvider>
      <ReceiptProvider>
        <Router>
          <Routes>
            {/* one route for both "/" (new) and "/:id" (shared) so sharing
                updates the URL without remounting */}
            <Route path="/:id?" element={<ReceiptPage />} />
          </Routes>
        </Router>
      </ReceiptProvider>
    </AuthProvider>
  );
}

export default App;
